import React from 'react';

import Login from 'pages/Login';
import Signon from 'pages/Signon';
import LandingPage from 'pages/LandingPage';
import LandingPageFeide from 'pages/LandingPageFeide';
import ScreeningTest from 'pages/ScreeningTest';
import CustomLogin from 'pages/CustomLogin';

// import PermissionRoute from 'components/PermissionRoute';
// import PERMISSIONS from 'utils/permissions';

import {BrowserRouter as Router, Route} from 'react-router-dom';
import {EnvironmentBanner} from 'components/EnvironmentBanner';

import {ENVIRONMENT} from 'constants/index';

// import './App.scss';

const TEST_ROUTE_REFRESH_PARAM = '__test_route_refresh';

const FreshScreeningTestRoute = (props) => {
	const [isReady, setIsReady] = React.useState(false);

	React.useEffect(() => {
		const url = new URL(window.location.href);

		if (!url.searchParams.has(TEST_ROUTE_REFRESH_PARAM)) {
			url.searchParams.set(TEST_ROUTE_REFRESH_PARAM, Date.now());
			window.location.replace(url.toString());
			return;
		}

		url.searchParams.delete(TEST_ROUTE_REFRESH_PARAM);
		window.history.replaceState(
			window.history.state,
			'',
			`${url.pathname}${url.search}${url.hash}`
		);
		setIsReady(true);
	}, []);

	return isReady ? <ScreeningTest {...props} /> : null;
};

const App = () => {
	// const auth = useSelector((state) => state.auth);

	return (
		<div className="PageWrapper">
			<EnvironmentBanner environment={ENVIRONMENT} />
			<Router>
				<Route path="/" exact component={LandingPage} />
				<Route path="/feide" exact component={LandingPageFeide} />
				<Route path="/custom-login" component={CustomLogin} />
				<Route path="/login/" component={Login} />
				<Route path="/signon/" component={Signon} />
				<Route path="/test/" component={FreshScreeningTestRoute} />
			</Router>
		</div>
	);
};

export default App;
